<h5 class="mb-3">
  <strong>Basic</strong>
</h5>
<div class="mb-5">
  <nz-switch [(ngModel)]="switchValue" class="mb-3 mr-3"></nz-switch>
  <nz-switch [ngModel]="true" nzCheckedChildren="On" nzUnCheckedChildren="Off"></nz-switch>
  <nz-switch [ngModel]="true" nzLoading></nz-switch>
</div>